module.exports = __webpack_public_path__ + "static/ziarnista_czarka-8a74f561f74e1565a79f85d8eee8ffe8.png";